import styled from "styled-components";
import { theme } from "../../../helpers/theme";
import { useEffect, useState } from "react";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useParams } from "react-router";
import { GetOrdersDetailsPayloadResponse } from "../../../services/orders/orders-details-get-by-id/types";
import { getOrdersDetailsGetById } from "../../../services/orders/orders-details-get-by-id";
import { LoadingBackDrop } from "../../../components/loader";
import { GoBackButton } from "../../../components/GoBackButton";
import { StyledButton } from "../../../components/Button/button";
import { getOrdersPricelistOffersById } from "../../../services/orders/pricelist-offers-get-by-id";
import {
  OfferType,
  PricelistOffersGetByIdPayload,
  StatusOfOffer,
  OrderStatus,
} from "../../../services/orders/pricelist-offers-get-by-id/types";
import OfferingOrderDetailsTable from "./components/offering-order-details-table";
import OfferingOfferDetailsTable from "./components/offering-offer-details-table";
import OfferingDetailsSection from "./components/offering-details-section";
import { addOffer } from "../../../services/offers/offer-add";
import { toast } from "react-toastify";
import { settings } from "../../../helpers/toast.settings";
import { getStatusFromEnum } from "./helpers";
import { changeOrderStatus } from "../../../services/orders/change-status";
import { offerClientPreAcceptNotification } from "../../../services/offers/offer-client-preaccept-notification";
import { offerClientFinalAcceptNotification } from "../../../services/offers/offer-client-final-notification";

const OperatorOrdersOffering = () => {
  const { id } = useParams();

  const [ordersDetails, setOrdersDetails] = useState<
    GetOrdersDetailsPayloadResponse[]
  >([]);
  const [ordersPricelist, setOrdersPricelist] =
    useState<PricelistOffersGetByIdPayload>();
  const queryClient = useQueryClient();
  const body = {
    id_zamowienie: id,
  };
  const GetOrdersDetails = useQuery(
    ["OrdersDetail"],
    () => getOrdersDetailsGetById(body),
    {
      refetchOnMount: true,
      refetchOnWindowFocus: false,
      onSuccess(res) {
        setOrdersDetails([res.data.payload]);
      },
    }
  );
  const GetOrdersPricelistOffers = useQuery(
    ["OrdersPricelistOffers"],
    () => getOrdersPricelistOffersById(body),
    {
      refetchOnMount: true,
      refetchOnWindowFocus: false,

      onSuccess(res) {
        if (res.data.payload)
          setOrdersPricelist(GetOrdersPricelistOffers.data?.data.payload);
      },
    }
  );
  const AddOfferMutation = useMutation(addOffer, {
    onSuccess: () => {
      queryClient.invalidateQueries(["OrdersPricelistOffers"]);
      toast.success("Dodano nową ofertę", {
        toastId: "AddOfferSuccessfully",
        ...settings,
      });
    },
  });
  const PreAcceptNotificationMutation = useMutation(
    offerClientPreAcceptNotification,
    {
      onSuccess: () => {
        toast.success("Wysłano ofertę wstępną!", {
          toastId: "PreAcceptNotificatioSendSuccessfully",
          ...settings,
        });
      },
    }
  );
  const FinalAcceptNotificationMutation = useMutation(
    offerClientFinalAcceptNotification,
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["OrdersDetail"]); //todo
        queryClient.invalidateQueries(["OrdersPricelistOffers"]); //todo
        toast.success("Wysłano ofertę ostateczną!", {
          toastId: "FinalAcceptNotificatioSendSuccessfully",
          ...settings,
        });
      },
    }
  );
  const ChangeOrderStatusMutation = useMutation(changeOrderStatus, {
    onSuccess: (res) => {
      queryClient.invalidateQueries(["OrdersDetail"]);
      queryClient.invalidateQueries(["OrdersPricelistOffers"]);
      toast.success("Zmieniono status oferty", {
        toastId: "ChangeOrderStatusSuccessfully",
        ...settings,
      });
    },
    onError: (err: any) => {
      if (err && err.response.data.error_code === 24) {
        toast.error("Zamówienie musi posiadać ofertę ze statusem - Gotowa", {
          toastId: "ChangeOrderStatusError",
          ...settings,
        });
      }
    },
  });

  const handleReject = () => {
    if (
      GetOrdersPricelistOffers.data?.data.payload.status_zamowienia === 3 ||
      GetOrdersPricelistOffers.data?.data.payload.status_zamowienia === 5 ||
      GetOrdersPricelistOffers.data?.data.payload.status_zamowienia === 7 ||
      GetOrdersPricelistOffers.data?.data.payload.status_zamowienia === 4
    ) {
      toast.error(
        "Zamówienie nie może posiadac statusów Rezygnacja, Anulowane, Zaakceptowane lub Zrealizowane",
        {
          toastId: "OrderRejectError",
          ...settings,
        }
      );
    } else {
      const body = {
        id_zamowienie: id,
        status_zamowienia:
          GetOrdersPricelistOffers.data?.data.payload.status_zamowienia === 0 ||
          GetOrdersPricelistOffers.data?.data.payload.status_zamowienia === 6
            ? 5
            : 3,
      };
      ChangeOrderStatusMutation.mutate(body);
    }
  };
  if (
    GetOrdersDetails.isLoading ||
    GetOrdersDetails.isRefetching ||
    GetOrdersPricelistOffers.isLoading ||
    GetOrdersPricelistOffers.isRefetching ||
    ChangeOrderStatusMutation.isLoading
  ) {
    return <LoadingBackDrop loading={true} />;
  }
  return (
    <OperatorOrdersOfferingContainer>
      <GoBackButton description={"Powrót"} />
      <ButtonsWrapper>
        <StyledButton
          variant="contained"
          sx={{ width: "202px" }}
          onClick={() =>
            AddOfferMutation.mutate({
              data_wprowadzenia: new Date(),
              status_oferty: StatusOfOffer.nowa,
              rodzaj_oferty: OfferType.magazyn_dedykowany,
              notatka_konsultanta: null,
              id_zamowienia:
                GetOrdersPricelistOffers.data?.data.payload.id_zamowienie,
            })
          }
        >
          Dodaj nową ofertę
        </StyledButton>
        <StyledButton
          variant="contained"
          sx={{ width: "202px" }}
          onClick={handleReject}
        >
          Odrzuć zamówienie
        </StyledButton>
        <StyledButton
          variant="contained"
          sx={{ width: "202px" }}
          onClick={() => {
            if (
              (GetOrdersPricelistOffers.data?.data.payload.status_zamowienia ===
                OrderStatus.Nowe ||
                GetOrdersPricelistOffers.data?.data.payload
                  .status_zamowienia === OrderStatus.Rezygnacja) &&
              GetOrdersPricelistOffers.data?.data.payload.oferty.filter(
                (item) =>
                  item.status_oferty === StatusOfOffer.gotowa ||
                  item.status_oferty === StatusOfOffer.nowa
              ).length > 0
            ) {
              PreAcceptNotificationMutation.mutate({
                id_zamowienie:
                  GetOrdersPricelistOffers.data?.data.payload.id_zamowienie,
              });
            } else {
              toast.error(
                "Status zamówienia musi posiadać wartość nowe lub rezygnacja oraz co najmniej jedna oferta musi być w statusie gotowa lub nowa",
                {
                  toastId: "PreAcceptNotificatioSendError",
                  ...settings,
                }
              );
            }
          }}
        >
          Wyślij wstępną ofertę
        </StyledButton>
        <StyledButton
          variant="contained"
          sx={{ width: "202px" }}
          onClick={() => {
            if (
              GetOrdersPricelistOffers.data?.data.payload.status_zamowienia ===
                OrderStatus.Wstepna_akceptacja &&
              GetOrdersPricelistOffers.data?.data.payload.oferty.filter(
                (item) => item.status_oferty === StatusOfOffer.gotowa
              ).length === 1
            ) {
              FinalAcceptNotificationMutation.mutate({
                id_zamowienie:
                  GetOrdersPricelistOffers.data?.data.payload.id_zamowienie,
              });
            } else {
              toast.error(
                "Status zamówienia musi posiadać wartość Wstępna akceptacja oraz tylko jedna oferta musi być w statusie gotowa",
                {
                  toastId: "FinalAcceptNotificatioSendError",
                  ...settings,
                }
              );
            }
          }}
        >
          Wyślij ostateczną ofertę
        </StyledButton>
        <StyledButton
          variant="contained"
          sx={{ width: "202px" }}
          onClick={() => {
            if (
              ordersDetails[0].status_zamowienia ===
                OrderStatus.Do_ostatecznej_akceptacji ||
              (ordersDetails[0].status_zamowienia ===
                OrderStatus.Weryfikacja_klienta &&
                ordersDetails[0].klient.weryfikacja_klienta === 1)
            ) {
              ChangeOrderStatusMutation.mutate({
                id_zamowienie: id,
                status_zamowienia: OrderStatus.W_trakcie_realizacji,
              });
            } else if (
              ordersDetails[0].status_zamowienia ===
                OrderStatus.Weryfikacja_klienta &&
              ordersDetails[0].klient.weryfikacja_klienta === 0
            ) {
              toast.error("Klient nie został jeszcze zweryfikowany", {
                toastId: "ChangeOrderStatusError",
                ...settings,
              });
            } else {
              toast.error(
                "Zamówienie o statusie " +
                  getStatusFromEnum(ordersDetails[0].status_zamowienia) +
                  " nie może być w trakcie realizacji",
                {
                  toastId: "ChangeOrderStatusError",
                  ...settings,
                }
              );
            }
          }}
        >
          Do realizacji
        </StyledButton>
        <StyledButton
          variant="contained"
          sx={{ width: "202px" }}
          onClick={() => {
            if (
              ordersDetails[0].status_zamowienia ===
              OrderStatus.W_trakcie_realizacji
            ) {
              ChangeOrderStatusMutation.mutate({
                id_zamowienie: id,
                status_zamowienia: OrderStatus.Zrealizowano,
              });
            } else {
              toast.error(
                "Zamówienie o statusie " +
                  getStatusFromEnum(ordersDetails[0].status_zamowienia) +
                  " nie może zostać zrealizowane",
                {
                  toastId: "ChangeOrderStatusError",
                  ...settings,
                }
              );
            }
          }}
        >
          Zrealizowano
        </StyledButton>
      </ButtonsWrapper>
      <OfferingOrderDetailsTable ordersDetails={ordersDetails} />
      {GetOrdersPricelistOffers.data?.data.payload.oferty.map((item, index) => (
        <>
          <OfferingDetailsSection
            pricelistOffer={item}
            additionalServicesQuantity={
              ordersDetails[0].uslugi_zamowione.ilosc_dodatkowych
            }
            isDeletable={
              GetOrdersPricelistOffers.data?.data.payload.oferty[index]
                .status_oferty !== StatusOfOffer.zaakceptowana
            }
          />
        </>
      ))}
    </OperatorOrdersOfferingContainer>
  );
};

export default OperatorOrdersOffering;
const OperatorOrdersOfferingContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 80px;
  @media ${theme.device.laptop} {
    margin-left: 310px;
    padding-right: 50px;
  }
`;
const ButtonsWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  @media ${theme.device.Mtablet} {
    justify-content: center;
  }
  gap: 20px;
  margin-top: 30px;
  margin-bottom: 10px;
`;
